"use strict";

exports.__esModule = true;
exports.default = range;
function range(start, end) {
  var itemsAmount = Math.abs(start - end);
  var _range = Array.apply(null, {
    length: itemsAmount
  }).map(Number.call, Number);
  if (start < end) {
    return _range.map(item => item + start);
  }
  return _range.map((_, index) => start - index);
}
//# sourceMappingURL=range.js.map